module.exports = __webpack_public_path__ + "static/fonts/Linearicons-Free.b9b7f23.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Linearicons-Free.eot
// module id = yXwQ
// module chunks = 1